// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import PickupDateTime from './PickupDateTime';
import DropoffDateTime from './DropoffDateTime';
import GeburtsdatumPicker from './GeburtsdatumPicker';
import GeburtsdatumPickerv2 from './GeburtsdatumPickerv2';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './theme'; // Your custom MUI theme
import './index.css';

const pickupRoot = document.getElementById('pickup-root');
const dropoffRoot = document.getElementById('dropoff-root');
const geburtsdatumRoot = document.getElementById('geburtsdatum-root');
const geburtsdatumRootv2 = document.getElementById('geburtsdatum-root-v2');

if (pickupRoot) {
  ReactDOM.createRoot(pickupRoot).render(
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <PickupDateTime />
    </ThemeProvider>
  );
}

if (dropoffRoot) {
  ReactDOM.createRoot(dropoffRoot).render(
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DropoffDateTime />
    </ThemeProvider>
  );
}

if (geburtsdatumRoot) {
  ReactDOM.createRoot(geburtsdatumRoot).render(
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GeburtsdatumPicker />
    </ThemeProvider>
  );
}

if (geburtsdatumRootv2) {
  ReactDOM.createRoot(geburtsdatumRootv2).render(
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GeburtsdatumPickerv2 />
    </ThemeProvider>
  );
}